import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useMount } from 'react-use'

const ApiStatusWarning: React.FC = () => {
  const [unavailableServices, setUnavailableServices] = useState<string[]>([])

  const checkStatus = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_RQ_API_URL}/api-status`,
      )

      if (response.ok) {
        const data = await response.json()
        const unavailable = Object.keys(data).filter(
          (key) => data[key] === false,
        )
        setUnavailableServices(unavailable)
      } else {
        setUnavailableServices([])
      }
    } catch (error) {
      setUnavailableServices([])
    }
  }

  useMount(async () => {
    await checkStatus()
  })

  useEffect(() => {
    if (unavailableServices.length > 0) {
      const interval = setInterval(checkStatus, 30000)
      return () => clearInterval(interval)
    }
  }, [unavailableServices])

  if (unavailableServices.length === 0) {
    return null
  }

  const message = `The API has reported the following services as unavailable: ${unavailableServices.join(', ')}.`
  const vpnMessage =
    unavailableServices.includes('compass') ||
    unavailableServices.includes('mongo')
      ? ' Are you connected to the VPN?'
      : ''

  return createPortal(
    <div
      className="bg-destructive z-api-status-warning fixed bottom-0 w-full p-2.5
        text-center text-white"
    >
      {message}
      {vpnMessage}
    </div>,
    document.body,
  )
}

export default ApiStatusWarning
